import {
  AlreadyAccountMemberError,
  ChatCreditsExhaustedError,
  FolderNotEmptyError,
  ForbiddenError,
  InvitationExpiredError,
  InvitationMismatchError,
  InvitationNotFoundError,
  LastAccountOwnerError,
  MembershipLimitError,
  MonthlyLimitExceededError,
  NotFoundError,
  ProjectExpiredError,
  type StandardError,
  StandardRestError,
  UnauthorizedError,
} from '@/modules/errors'

type ErrorConstructor = new (
  message?: string,
  status?: number,
  body?: Record<string, unknown>,
  code?: string,
) => StandardError

const UNKNONW_ERROR = 'UNKNOWN'

const errorsByStatus: Record<number, ErrorConstructor> = {
  400: StandardRestError,
  401: UnauthorizedError,
  403: ForbiddenError,
  404: NotFoundError,
  500: StandardRestError,
}

const errorsByCode: Record<string, ErrorConstructor> = {
  [AlreadyAccountMemberError.CODE]: AlreadyAccountMemberError,
  [LastAccountOwnerError.CODE]: LastAccountOwnerError,
  [InvitationMismatchError.CODE]: InvitationMismatchError,
  [InvitationNotFoundError.CODE]: InvitationNotFoundError,
  [InvitationExpiredError.CODE]: InvitationExpiredError,
  [FolderNotEmptyError.CODE]: FolderNotEmptyError,
  [MembershipLimitError.CODE]: MembershipLimitError,
  [ProjectExpiredError.CODE]: ProjectExpiredError,
  [MonthlyLimitExceededError.CODE]: MonthlyLimitExceededError,
  [ChatCreditsExhaustedError.CODE]: ChatCreditsExhaustedError,
}

export const ErrorFactory = (
  message: string,
  status: number,
  body: Record<string, unknown> = {},
  code: string = UNKNONW_ERROR,
): never => {
  let LukitaError = errorsByStatus[status] || errorsByStatus[500]

  if (code && code !== UNKNONW_ERROR && errorsByCode[code]) {
    LukitaError = errorsByCode[code]
  }

  return Promise.reject(new LukitaError(message, status, body, code)) as never
}
